export default __webpack_public_path__ + "static/media/tree.3faad5ca.png";